<script lang="ts">
	import {
		FormColumnWrapper,
		ReferralHero,
		ReferralAlertBanner,
		ReferralValueProposition,
		ReferralTargetAudience,
		ReferralCallToAction,
		ReferralSuccessStory,
		ReferralPayoutStructure
	} from "#lib/web-ui/home-buyers-template/content/index.js";
	import Section from "#lib/web-ui/primitives/section.svelte";
	import { AcquisitionReferralCreateForm } from "#lib/web-ui/fergmar-com/acquisition-referral/index.js";
	import { getTemplateContext } from "#lib/web-ui/home-buyers-template/template-context.svelte.js";

	const templateContext = getTemplateContext();
</script>

<svelte:head>
	<title>Get Paid to Take Pictures of Houses | {templateContext.siteName}</title>
	<meta
		name="description"
		content="Earn extra income by simply taking photos of homes in need of repair. Help us find properties to buy while making money in your spare time."
	/>
	<meta
		name="keywords"
		content="real estate referral, property scouting, earn money taking photos, distressed properties, real estate leads, property finder, cash for referrals"
	/>
	<meta
		property="og:title"
		content="Get Paid to Take Pictures of Houses | {templateContext.siteName}"
	/>
	<meta property="og:site_name" content={templateContext.siteName} />
	<meta
		property="og:description"
		content="Earn extra income by simply taking photos of homes in need of repair. Help us find properties to buy while making money in your spare time."
	/>
</svelte:head>

<ReferralHero />

<Section class="bg-border/50">
	<ReferralAlertBanner />

	<div class="grid grid-cols-1 gap-12 lg:grid-cols-2 lg:gap-16">
		<div class="space-y-8">
			<ReferralPayoutStructure />
			<ReferralValueProposition />
			<ReferralTargetAudience />
			<ReferralCallToAction />
			<ReferralSuccessStory />
		</div>

		<FormColumnWrapper
			title="Submit Property"
			description="Get Paid for Finding Distressed Properties"
		>
			<AcquisitionReferralCreateForm />
		</FormColumnWrapper>
	</div>
</Section>
